import { createStyles } from '@mantine/core';
import { getTypographyStyles } from 'src/theme/themeConfig';

export const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    cmodal: {
      '& .mantine-Drawer-drawer': {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        textAlign: 'center',
        background: 'linear-gradient(270deg, rgba(86, 135, 230, 0.8) 0%, rgba(100, 65, 237, 0.8) 120.05%)',
        backdropFilter: 'blur(34px)',
        padding: '29px 8%',

      },
      '& .mantine-Paper-root': { maxHeight: '250px' },
    },
    modalContentWrapper: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      textAlign: 'center',
    },
    fileLabel: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '0px 12px',
      gap: '10px',
      background: colors.bg.default,
      borderRadius: '8px',
      height: '46px',
      position: 'relative',
      overflow: 'hidden',
      color: colors.primary.default,
      border: `1px solid ${colors.disabled.muted}`,
      transition: '0.2s',
      ...getTypographyStyles('heading_2xs_semibold'),
      ':hover': {
        cursor: 'pointer !important',
        color: colors.fg.subtle,
        border: `1px solid ${colors.primary.default}`,
      },
    },
    fileLabelBg: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      transition: 'width 2s ease',
      zIndex: -1,
      // backgroundColor: '#ffffff00'
    },
    successBg: {
      backgroundColor: '#6f9412',
    },
    fileInput: {
      display: 'none',
    },
    popularBankList: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'space-between',
    },
    contentContainer: {
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'space-between',
      paddingTop: '0',
      [`@media (min-width: ${theme.breakpoints.xs})`]: {
        height: '100%',
      },
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '20px',
    },
    subtext: {
      marginTop: '8px',
      ...getTypographyStyles('content_sm_regular'),
    },
    newbuttonContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      gap: '8px',
    },
    inputDescription: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#8C8C8C',
      marginTop: '8px',
    },
    inputError: {
      color: 'red',
    },
    panModalWrapper: {
      height: 200,
    },
    divider: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 'auto',
      marginBottom: 10,
    },
    dividerSpan: {
      height: '1px',
      width: '45%',
      background: 'red',
      border: `1px solid ${colors.disabled.muted}`,
    },
    buttonFaster: {
      display: 'flex',
      background: colors.primary.muted,
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 4,
      padding: '2px 6px',
      '& svg': {
        paddingRight: 4,
      },
      '& p': {
        color: colors.primary.default,
        ...getTypographyStyles('content_xs_medium'),
      },
    },
    tAndCText: {
      ...getTypographyStyles('content_2xs_regular'),
      color: colors.primary.default,
      padding: 6,
      paddingBottom: 0,
    },
    // dob
    inputDob: {
      borderRadius: '4px',
      height: '44px',
      border: `1px solid ${colors.disabled.muted}`,
      backgroundColor: colors.bg.default,
      ...getTypographyStyles('content_sm_regular'),
      '&[data-with-icon]': {
        paddingLeft: '48px',
      },
    },
    // pan image upload screen
    aadharImgWrapper: {
      display: 'flex',
      justifyContent: 'center',

    },
    aadharImg: {
      width: '85%',
      height: '100%',
      objectFit: 'contain',
      opacity: '0.75',
    },
  };
});

export default useStyles;
